<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 11:15:29
 * @LastEditors: xiaobai
 * @LastEditTime: 2021-06-11 11:38:34
 * @FilePath: /fujian/src/views/yewu/components/highway_project.vue
-->
<template>
  <div class="mt-10 heihway_box">
    <div class="heihway_box_a">
      <img v-if="loading" class="loading_img" src="../../../assets/imgaes/loading.7.gif">
      <el-row v-else :gutter="50">
        <el-col :md="10">
          <div style="overflow: hidden; border-radius: 10px;">
           <img :src="resourcesDtoListObj.imgUrl" class="pro_img">
          </div>
        </el-col>
        <el-col :md="14">
          <div class="pro_title">{{resourcesDtoListObj.name}}</div>
          <div class="pro_content">{{resourcesDtoListObj.content}}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return{
      loading:true,
      resourcesDtoListObj:{},
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      const id = this.$store.state.navList[2].children[0].id
      axios.post('/home/engineering/case', { projectId: id}).then((res) => {
        this.loading = false
        const resourcesDtoList = res.data.data.resourcesDtoList
        resourcesDtoList.map(item=>{
          this.$set(item,'imgUrl',res.data.data.imgUrl +'/'+ item.url)
        })
        this.resourcesDtoListObj = resourcesDtoList[0]
      })
    }
  }
}
</script>

<style>

</style>